/* Product recommendations. Loaded by sections/product-recommendations.liquid.
   Fetches the section filled with recommendations (product_recommendations
   endpoint + Section Rendering API) when it nears the viewport, swaps it in,
   and wires the carousel arrows. No products → the section stays hidden. */

(function () {
  'use strict';
  if (!window.Mim) return;
  const Mim = window.Mim;

  const Recommendations = {
    init() {
      Mim.utils.qsa('[data-mim-recommendations]').forEach((root) => this.setup(root));
      document.addEventListener('shopify:section:load', (e) => {
        Mim.utils.qsa('[data-mim-recommendations]', e.target).forEach((root) => this.setup(root));
      });
    },

    setup(root) {
      if (root.dataset.mimRecoReady || root.hasAttribute('data-mim-recommendations-off')) return;
      root.dataset.mimRecoReady = 'true';
      if (root.querySelector('[data-mim-recommendations-content]')) {
        this.wire(root);
        return;
      }
      if (!('IntersectionObserver' in window)) {
        this.load(root);
        return;
      }
      const io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        this.load(root);
      }, { rootMargin: '0px 0px 400px 0px' });
      // A hidden element never intersects — observe its parent slot instead.
      io.observe(root.parentElement || root);
    },

    async load(root) {
      try {
        const res = await fetch(root.dataset.url);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const content = doc.querySelector('[data-mim-recommendations-content]');
        if (!content) return;
        root.replaceChildren(content);
        root.hidden = false;
        this.wire(root);
      } catch (err) {
        /* stay hidden */
      }
    },

    wire(root) {
      const carousel = root.querySelector('[data-mim-carousel]');
      if (carousel && Mim.modules.carousel) Mim.modules.carousel.setup(carousel);
    },
  };

  Mim.ready(() => Mim.register('recommendations', Recommendations));
})();
